__turbopack_context__.v({
  "cart": "cart-module-scss-module__mRvCIG__cart",
  "cartCollaterals": "cart-module-scss-module__mRvCIG__cartCollaterals",
  "cartEmpty": "cart-module-scss-module__mRvCIG__cartEmpty",
  "cartWrapper": "cart-module-scss-module__mRvCIG__cartWrapper",
  "checkoutButton": "cart-module-scss-module__mRvCIG__checkoutButton",
  "shippingUnavailableMessage": "cart-module-scss-module__mRvCIG__shippingUnavailableMessage",
  "table": "cart-module-scss-module__mRvCIG__table",
});
